<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.nick_name }}</div>
            <router-link
              v-if="levelConf[userInfo.level]"
              class="member acea-row row-middle"
              :to="'/user/vip'"
            >
              <img :src="levelConf[userInfo.level].icon" />
              {{ levelConf[userInfo.level].name }}
            </router-link>
          </div>
          <router-link :to="'/user/data'" class="id" v-if="userInfo.mobile">
            ID：{{ userInfo.id || 0
            }}<span class="iconfont icon-bianji1"></span>
          </router-link>
          <router-link :to="'/user/binding'" class="binding" v-else>
            <span>绑定手机号</span>
          </router-link>
        </div>
      </div>
      <div class="ub ubv ubh-c ub-sa">
        <span
          class="iconfont icon-shezhi"
          @click="$router.push({ path: '/user/data' })"
        ></span>
        <div class="iconfont icon-erweima" @click="createMyCode()"></div>
      </div>
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-middle">
        <router-link :to="{ path: '/user/account' }" class="item">
          <div>我的佣金</div>
          <div class="num">{{ userInfo.money || 0 }}</div>
        </router-link>

        <router-link :to="'/user/integral'" class="item">
          <div>当前积分</div>
          <div class="num">{{ userInfo.score || 0 }}</div>
        </router-link>

        <router-link :to="'/user/fans'" class="item">
          <div>我的粉丝</div>
          <div class="num">{{ fans_count || 0 }}</div>
        </router-link>
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/100'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.WAIT_PAY > 0"
                >{{ orderStatusNum.WAIT_PAY }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.PAY_SUCCESS > 0"
                >{{ orderStatusNum.PAY_SUCCESS }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 9 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.SEND_OUT_GOODS > 0"
                >{{ orderStatusNum.SEND_OUT_GOODS }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <!--<router-link :to="{ path: '/order/list/' + 3 }" class="item">-->
          <!--<div class="pictrue">-->
          <!--<img src="@assets/images/dpj.png" />-->
          <!--<span-->
          <!--class="order-status-num"-->
          <!--v-if="orderStatusNum.evaluated_count > 0"-->
          <!--&gt;{{ orderStatusNum.evaluated_count }}</span-->
          <!--&gt;-->
          <!--</div>-->
          <!--<div>待评价</div>-->
          <!--</router-link>-->
          <!--<router-link :to="'/order/refund_list'" class="item">-->
          <!--<div class="pictrue">-->
          <!--<img src="@assets/images/sh.png" />-->
          <!--<span-->
          <!--class="order-status-num"-->
          <!--v-if="orderStatusNum.refund_count > 0"-->
          <!--&gt;{{ orderStatusNum.refund_count }}</span-->
          <!--&gt;-->
          <!--</div>-->
          <!--<div>售后/退款</div>-->
          <!--</router-link>-->
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.url"
            >
              <div class="pictrue">
                <img :src="item.icon" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <MyQr
      :posterImageStatus="posterImageStatus"
      @setPosterImageStatus="posterImageStatus = false"
      :posterData="userInfo"
    ></MyQr>
  </div>
</template>
<script>
import { getUser, getLevelConf } from "@api/user";
import { getQrBase64code } from "@api/store";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import MyQr from "@components/MyQr";

const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    MyQr
  },
  props: {},
  data: function() {
    return {
      fans_count: 0,
      userInfo: {},
      MyMenus: [
        {
          name: "进店核销",
          url: "/WriteOffGoods/Index",
          icon:
            "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/hexiao.png"
        },
        {
          name: "领券中心",
          url: "/user/user_coupon",
          icon:
            "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/coupon.png"
        },
        {
          name: "推广海报",
          url: "/user/poster",
          icon:
            "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/poster.png"
        },
        {
          name: "我的客服",
          url: "/customer/list",
          icon:
            "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/customer.png"
        },
        {
          name: "艾灸师认证",
          url: "/user/auth",
          icon:
            "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/three.png"
        },
        {
          name: "买一赠一",
          url: "/user/gift",
          icon:
            "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/gift.png"
        },
        {
          name: "关于程序",
          url: "/user/gift",
          icon:
            "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/about.png"
        }
      ],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      levelConf: [],
      posterImageStatus: false
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.user = this.$store.state.app.userInfo;
    getLevelConf().then(r => {
      this.levelConf = r.data;
    });
    this.User();
    // this.MenuUser();
    this.isWeixin = isWeixin();
    // this.posterData.uid=this.user.id||0;
  },
  methods: {
    changeswitch(data) {
      this.switchActive = data;
    },
    User() {
      getUser()
        .then(res => {
          this.userInfo = res.data.userInfo;
          this.orderStatusNum = res.data.orderStatus;
          this.fans_count = res.data.fans_count;
        })
        .catch(err => {
          console.log(err);
        });
    },
    async createMyCode() {
      if (!this.userInfo.qr) {
        this.userInfo.qr = await getQrBase64code().then(r => r.data);
      }
      this.posterImageStatus = true;
    },
    MenuUser: function() {
      // let that = this;
      // getMenuUser().then(res => {
      //   that.MyMenus = res.data.routine_my_menus;
      // });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].url;

      if (index === 6) {
        //关于我们点击
        return this.$dialog.alert({
          mes: "爱灸堂微信商城 " + this.$version,
          opts: { title: "关于" }
        });
      }
      if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
        if (!this.userInfo.is_promoter)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }

      this.$router.push({ path: this.MyMenus[index].url });
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.icon-erweima {
  color: #fff;
  margin-top: 0.01rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
.member {
  color: #ffffff;
}
</style>
